import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';

import { useAppUpdate } from 'src/hooks/use-app-update';

import { Iconify } from 'src/components/iconify';

/**
 * Offers a reload when a newer build has gone live under this tab. Anchored
 * bottom-left so it never sits on top of the sonner toasts, which come in
 * bottom-right and are capped at one at a time.
 */
export function AppUpdatePrompt() {
  const { isUpdateAvailable, dismiss, reload } = useAppUpdate();

  return (
    <Snackbar
      open={isUpdateAvailable}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      message="A new version of nexmail is available."
      action={
        <>
          <Button color="primary" size="small" onClick={reload}>
            Reload
          </Button>
          <IconButton size="small" color="inherit" onClick={dismiss} aria-label="Dismiss">
            <Iconify icon="mingcute:close-line" width={18} />
          </IconButton>
        </>
      }
    />
  );
}
